export function sanitizeReferrerAndReferringDomain(url: string): { referrer: string; referringDomain: string } {
  try {
    const newURL = new URL(url);
    newURL.searchParams.delete('authorization');
    return {referrer: newURL.toString(), referringDomain: newURL.hostname};
  } catch (error) {
    return {referrer: '', referringDomain: ''};
  }
}